import { render, staticRenderFns } from "./AddressBookContacts.vue?vue&type=template&id=43f35673&"
import script from "./AddressBookContacts.vue?vue&type=script&lang=ts&"
export * from "./AddressBookContacts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports